import { IItineraryProps } from 'components/shared/ArrayFields/types';
import { SNACKBAR_SKIN } from 'components/shared/Snackbar';
import store from 'configureStore';
import { showSnackbar } from 'hooks/useSnackbar';
// eslint-disable-next-line import/named
import { always, map, pipe, when } from 'ramda';
// eslint-disable-next-line import/no-duplicates
import { ITINERARIES_ITEM_TYPE_TO_KEY_MAP } from 'store/admin/itineraries';
import { accountIdSelector } from 'store/user/selectors';
import {
  getFileByTask,
  getFileDownloadingConfig,
  getTaskId,
  isDownloadingInProgress,
} from 'utils/filesDownloaders/downloadingTaskManager';

import { isDefined, isNotDefined } from '../../utils/ramda';
import { DOMAINS, getDomain } from '../domain';
import { decamelize } from '../humps';
import { TItineraryItemType } from '../types';
import { ITask } from './types';

interface ISaveAsDOCXParams {
  item: IItineraryProps;
  itinerariesItemType: TItineraryItemType;
  themeId: string;
  etag: string;
}

export function saveAsDOCX({ item, itinerariesItemType, themeId, etag }: ISaveAsDOCXParams) {
  if (isDownloadingInProgress(item.id)) {
    return;
  }

  async function run() {
    try {
      const encodedPoints = pipe(
        map((item: any) => ({ lat: Number(item?.latitude), lng: Number(item?.longitude) })),
        when(isDefined, pipe(JSON.stringify, window.btoa)),
        when(isNotDefined, always(undefined)),
      )(item.way || []);

      const proposalRouteName = decamelize(ITINERARIES_ITEM_TYPE_TO_KEY_MAP[itinerariesItemType]);
      const queue = `${getBaseRoute()}/${proposalRouteName}/${item.id}/files/docx`;
      const taskId = await getTaskId({ id: item.id, encodedPoints, themeId, etag }, queue);
      const sessionData: ITask = {
        taskId,
        title: item.title,
        itemId: item.id,
        time: Date.now(),
        queue,
        extension: 'docx',
      };

      await getFileByTask(getFileDownloadingConfig(sessionData), sessionData);
    } catch (e) {
      window.console.log('Error occurred:', e);

      //@ts-ignore
      showSnackbar({ text: 'Generating DOCX error. Please, try again.', type: SNACKBAR_SKIN.ERROR });
    }
  }

  run();
}

export function getBaseRoute() {
  const isAccountDomain = getDomain() === DOMAINS.ACCOUNT;

  if (isAccountDomain) {
    const state = store.getState();
    const accountId = accountIdSelector(state);

    return `acc/${accountId}`;
  }

  return '';
}
